import React from 'react';

import { Select } from 'antd';

import styled from 'styled-components';

import { NwButton } from '@components/Gui/NwButton';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { Option, OptGroup } = Select;

const Container = styled.div`
    display: flex;
    width: ${(props) => props.$width};

    .ant-btn:hover,
    .ant-btn:focus {
        border-color: rgba(0, 0, 0, 0.25) !important;
    }

    .ant-btn:hover {
        color: ${(props) => props.theme.DangerColor} !important;
    }

    .ant-select-selection {
        border-radius: ${(props) => props.$allowclear && '4px 0 0 4px'};
    }

    .ant-select-selector {
        border-radius: ${(props) => (!props.$allowClear ? '6px !important' : '6px 0 0 6px !important')};
    }
`;

const StyledSelect = styled(Select)`
    min-width: ${(props) => (props.width ? 'unset' : '200px')};
    width: ${(props) => props.width && '100%'};
    flex: 1 1 0;
`;

const ClearButtonStyle = {
    padding: '0 8px',
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0 4px 4px 0',
    color: 'rgba(0,0,0,0.25)',
    borderLeft: 'none',
    height: 'auto',
};

const CustomSelect = ({
    disableClosable,
    value,
    width,
    onChange,
    allowClear,
    children,
    style,
    mode,
    options,
    optionType,
    ...rest
}) => {
    const onClearSelect = () => {
        if (mode === 'multiple') {
            onChange([]);
        } else {
            onChange(null);
        }
    };

    return (
        <Container $width={width} $allowClear={allowClear} style={style}>
            {optionType === 'group' ? (
                <StyledSelect width={width} onChange={onChange} mode={mode} autoComplete="off" value={value} {...rest}>
                    {options[0].options.length &&
                        options[0].options.map((option) => {
                            return (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            );
                        })}
                    {options
                        .filter((optGroup) => optGroup.groupName && optGroup.options.length)
                        .map((optGroup) => {
                            return (
                                <OptGroup key={optGroup.groupName} label={optGroup.groupName}>
                                    {optGroup.options.map((option) => {
                                        return (
                                            <Option key={option.value} value={option.value}>
                                                {option.label}
                                            </Option>
                                        );
                                    })}
                                </OptGroup>
                            );
                        })}
                </StyledSelect>
            ) : (
                <StyledSelect
                    width={width}
                    onChange={onChange}
                    mode={mode}
                    options={options}
                    autoComplete="off"
                    value={value}
                    {...rest}
                >
                    {children}
                </StyledSelect>
            )}
            {!disableClosable && allowClear && (
                <NwButton icon={byPrefixAndName.fasl['times']} style={ClearButtonStyle} onClick={onClearSelect} />
            )}
        </Container>
    );
};

export default CustomSelect;
